import { styled } from '@/stitches.config';
import { Box, Card, InfoTitle, SectionTitle } from '@common/components';
import { ReactComponent as CalendarTitleIcon } from '@assets/icons/calendar-title.svg';
import { ReactComponent as SuccessIcon } from '@assets/icons/success.svg';

export const StyledCardContainer = styled(Card, { padding: '$2 $6', borderRadius: '$8' });

export const StyledHeader = styled(Box, { display: 'flex', alignItems: 'center', gap: '$2', marginBottom: '$4' });

export const StyledCalendarIcon = styled(CalendarTitleIcon, {
  width: '$6',
  height: '$6',
});

export const StyledTitle = styled(SectionTitle, {
  color: '$darkBlue300',
  fontSize: '$xl',
  fontWeight: '$bold',
  margin: '$0',
});

export const StyledSuccessIcon = styled(SuccessIcon, {
  color: '$green300',
});

export const StyledContentContainer = styled(Box, {
  display: 'flex',
  gap: '$12',
});

export const StyledSeparator = styled(Box, {
  borderBottom: '$borderWidths$1 solid $colors$seafoam300',
  marginBottom: '$4',
  marginTop: '$4',
});

export const StyledApptInfoContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

export const StyledApptInfoTitle = styled(InfoTitle, { marginBottom: '$4' });
export const StyledApptInfoValue = styled(Box, {
  fontSize: '$5',
  fontWeight: '$medium',
  lineHeight: '$6',
});

export const StyledActionsContainer = styled(Box, {
  display: 'flex',
  gap: '$4',
});
